import React from "react";
import { connect } from "react-redux";
import language from "../../../../language";
import { Loading } from "../../../Loader";
import "./styles.css";
import { Modal } from "../../../Modal";
import toastMessage from "../../../../utils/toastMessage";
import api from "../../../../utils/api";
import moment from "moment";
import ReusableDashboard from "../../../Dashboard/ReusableDashboard";
import { Table } from "../../../Table";
import { generateCSVData } from "../../../../utils/formatDataCSV";
import { downloadCSV } from "../../../../utils/csvDownloader";
import exportPDF from "../../../../utils/exportPDF";

class DashboardBloodCollection extends React.Component {
  state = {
    isLoading: false,
    data: {},
    page: 1,
    limit: 10,
    error: {},
    donationsCountByDonorType: {},
    ageGroupData: [],
    bloodGroupCounts: [],
    bloodCollectionStatsByGender: [],
    bloodCollectionStatsByBloodGroupCenterSite: [],
    regularityCountsLoading: false,
    bloodGroupCountsLoading: false,
    filter: {
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      // periodType: { value: "weekday", label: "Week day" },
      centers: [],
      centerSites: [],
      status: { value: "pending", label: "Pending" },
    },
  };

  componentDidMount = async () => {
    // const user = await getStorage();
    // await this.setState({ user });

    await this.fetchData();
    // await this.getCountBloodGroup();
    // await this.getBloodCollectionsStatsByGender(this.state.filter);
    // await this.getBloodCollectionsStatsByBloodGroupCenterSite(
    //   this.state.filter
    // );
  };

  onFilterChange(field, value) {
    const _filters = this.state.filter;
    if (field === "date-range") {
      _filters.startDate = value.startDate;
      _filters.endDate = value.endDate;
    } else {
      _filters[field] = value;
    }

    this.setState({
      filter: { ..._filters },
    });
  }

  onChangeText(field, e) {
    let { error } = this.state;

    let value = e && e?.target ? e?.target?.value : e;

    delete error[field];

    this.setState({
      [field]: value,
      error,
    });

    if (field === "filterStock") {
      this.getData(true, { stock: value?.value });
    }
  }

  fetchData = async () => {
    this.setState({
      regularityCountsLoading: true,
      bloodGroupCountsLoading: true,
    });

    const requestId = Date.now();
    this.latestFetchDataRequestId = requestId;

    const regularityReq = this.getDonationsCountByDonorType()
      .then((regularityData) => {
        if (this.latestFetchDataRequestId !== requestId) return;
        this.setState((prev) => ({
          data: { ...prev.data, regularityCounts: regularityData },
          regularityCountsLoading: false,
        }));
      })
      .catch((err) => {
        if (this.latestFetchDataRequestId !== requestId) return;
        console.error("donationsCountByDonorType error", err);
        toastMessage("error", err);
        this.setState({ regularityCountsLoading: false });
      });

    const bloodGroupReq = this.getCountBloodGroup()
      .then((bloodGroupData) => {
        if (this.latestFetchDataRequestId !== requestId) return;
        this.setState((prev) => ({
          data: { ...prev.data, bloodGroupCounts: bloodGroupData },
          bloodGroupCountsLoading: false,
        }));
      })
      .catch((err) => {
        if (this.latestFetchDataRequestId !== requestId) return;
        console.error("bloodGroup/count error", err);
        toastMessage("error", err);
        this.setState({ bloodGroupCountsLoading: false });
      });

    await Promise.allSettled([regularityReq, bloodGroupReq]);
  };

  getDonationsCountByDonorType = async () => {
    const startDate =
      this.state.filter?.startDate ||
      moment().subtract(1, "months").format("YYYY-MM-DD");
    const endDate = this.state.filter?.endDate || moment().format("YYYY-MM-DD");
    const centers = (this.state.filter?.centers || []).map(
      ({ value }) => value
    );
    const centerSites = (this.state.filter?.centerSites || []).map(
      ({ value }) => value
    );

    const opts = {
      method: "GET",
      url: `/bloodDonation/donationsCountByDonorType`,
      params: { startDate, endDate, centers, centerSites },
    };

    const { data } = await api(opts);
    return data;
  };

  getCountBloodGroup = async () => {
    const startDate =
      this.state.filter?.startDate ||
      moment().subtract(1, "months").format("YYYY-MM-DD");
    const endDate = this.state.filter?.endDate || moment().format("YYYY-MM-DD");
    const centers = (this.state.filter?.centers || []).map(
      ({ value }) => value
    );
    const centerSites = (this.state.filter?.centerSites || []).map(
      ({ value }) => value
    );

    const opts = {
      method: "GET",
      url: `/bloodDonation/bloodGroup/count`,
      params: { startDate, endDate, centers, centerSites },
    };

    const { data } = await api(opts);
    return data;
  };

  getListBloodGroup = async (bloodGroup, search = {}) => {
    try {
      this.setState({ isLoading2: true });

      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );
      const { page, limit } = this.state;

      const options = {
        method: "GET",
        url: `/bloodDonation/donation-list-by-blood-group`,
        params: {
          startDate,
          endDate,
          bloodGroup,
          centers,
          centerSites,
          page,
          limit,
          ...search,
        },
      };

      const { data } = await api(options);

      this.setState({
        data: { ...this.state.data, bloodGroupList: data?.data },
      });
      this.setState({ isLoading2: false });
    } catch (error) {
      this.setState({ isLoading2: false });
      console.error("error", error);
      toastMessage("error", error);
    }
  };

  getListBloodGroupExport = async (bloodGroup, search = {}) => {
    try {
      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );

      const options = {
        method: "GET",
        url: `/bloodDonation/donation-list-by-blood-group`,
        params: {
          startDate,
          endDate,
          bloodGroup,
          centers,
          centerSites,
          page: 1,
          limit: 100000,
          ...search,
        },
      };

      const { data } = await api(options);

      return data?.data?.donations;
    } catch (error) {
      console.error("error", error);
      toastMessage("error", error);
      return [];
    }
  };

  handleShowModal(modal, bloodGroup) {
    this.setState({
      [modal]: true,
      bloodGroup: bloodGroup,
    });
  }

  handleCloseModal() {
    this.setState({
      bloodGroup: null,
    });
  }

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getListBloodGroup(this.state.bloodGroup, {
      q: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donationNumber",
      },
      {
        title: language[this.props.defaultLanguage].firstName,
        key: "donor.firstName",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].lastName,
        key: "donor.lastName",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].gender,
        key: "donor.gender",
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
      },
    ];

    return headers;
  }

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getListBloodGroup(this.state.bloodGroup);
      }
    );
  }

  convertCamelCaseToWords(camelCaseString) {
    if (typeof camelCaseString !== "string" || camelCaseString.length === 0) {
      console.error("Input must be a non-empty string.");
      return "";
    }

    let result = camelCaseString.replace(/([A-Z])/g, " $1");

    result = result.charAt(0).toUpperCase() + result.slice(1);

    return result;
  }

  downloadExcel = async () => {
    try {
      const data = await this.getListBloodGroupExport(this.state.bloodGroup);

      const headers = this.returnTableHeaders();

      const csvData = generateCSVData(headers, data || []);

      downloadCSV(csvData, `Donation by Blood Group: ${this.state.bloodGroup}`);
    } catch (error) {
      console.error(error);
    }
  };

  downloadPDF = async () => {
    const headers = this.returnTableHeaders();

    const data = await this.getListBloodGroupExport(
      this.state.selectedAgeRange
    );

    exportPDF(
      `Donation by Blood Group: ${this.state.bloodGroup}`,
      headers,
      data || []
    );
  };

  render() {
    return (
      <>
        <ReusableDashboard
          filtersConfig={{
            hasCenters: true,
            hasSites: true,
            initialValues: this.state.filter,
            onFilterChange: (field, value) => this.onFilterChange(field, value),
          }}
          onFind={() => this.fetchData()}
          cardGroups={[
            {
              title: "Donation by regularity group",
              color: "#DDD",
              col: 3,
              isLoading: this.state.regularityCountsLoading,
              items: Object.keys(this.state.data.regularityCounts || {})
                .filter((item) => item.toLowerCase().includes("donation"))
                .map((key) => ({
                  title: this.convertCamelCaseToWords(key),
                  count: this.state.data.regularityCounts[key] || 0,
                })),
            },
            {
              title: "Donation by blood group",
              color: "#AC0207",
              col: 3,
              isLoading: this.state.bloodGroupCountsLoading,
              items: (this.state.data.bloodGroupCounts || [])
                .filter((item) => !!item.bloodGroup)
                .map((item) => {
                  const canPress = (item.count || 0) > 0;
                  return {
                    title: `Blood Group: ${item.bloodGroup}`,
                    count: item.count || 0,
                    onPress:
                      !!canPress &&
                      (() => {
                        this.handleShowModal("showModal", item.bloodGroup);
                        this.getListBloodGroup(item.bloodGroup);
                      }),
                  };
                }),
            },
          ]}
        />

        <Modal
          show={!!this.state.bloodGroup}
          title={`Donation by Blood Group: ${this.state.bloodGroup}`}
          handleClose={() => this.handleCloseModal()}
          size="lg"
        >
          {!this.state.data?.bloodGroupList || !!this.state.isLoading2 ? (
            <center>
              <Loading />
            </center>
          ) : (
            <div
              className="card-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <Table
                data={this.state.data?.bloodGroupList?.donations}
                isSearch
                page={this.state.data?.bloodGroupList?.currentPage}
                limit={this.state.data?.bloodGroupList?.count}
                search_text={this.state.search_text}
                totalPageCount={this.state.data?.bloodGroupList?.totalPages}
                isLoading={this.state.isLoading2}
                handlePagination={this.handlePagination.bind(this)}
                headers={this.returnTableHeaders()}
                addSearchButton
                searching={this.state.searching}
                handleSearch={this.handleSearch.bind(this)}
                handlePressSearch={() =>
                  this.handleRemoteSearch(this.state.search_text)
                }
                filters={[
                  {
                    type: "export",
                    title: language[this.props.defaultLanguage].export_,
                    button_type: "dropdown",
                    icon: "download",
                    options: [
                      {
                        name: "PDF",
                        onPress: this.downloadPDF.bind(this),
                      },
                      {
                        name: "CSV",
                        onPress: this.downloadExcel.bind(this),
                      },
                    ],
                  },
                ]}
              />
            </div>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(DashboardBloodCollection);
